import React, { ComponentProps } from 'react';
import classNames from 'classnames/bind';
import { withRenderFlag } from '@beef/react';

import styles from './styles.pcss';

const cn = classNames.bind(styles);

const _BaseListItem: React.FC<{
  baseClass?: string;
  isFullWidth?: boolean;
}> = ({ children, baseClass, isFullWidth = false }) => {
  return <li className={cn(baseClass, { 'full-width': isFullWidth })}>{children}</li>;
};

export const BaseListItem: React.FC<
  { shouldRender: boolean } & ComponentProps<typeof _BaseListItem>
> = withRenderFlag(_BaseListItem);
